import React from "react";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import "./Pagination.scss";

const Pagination = ({ cardType, update }) => {
  const productData = useSelector((state) => state.productData);
  const videoData = useSelector((state) => state.videoData);
  const productParams = useSelector((state) => state.productParams);
  const videoParams = useSelector((state) => state.videoParams);

  const getActiveData = {
    Product: productData,
    Video: videoData,
  };

  const getActiveParams = {
    Product: productParams,
    Video: videoParams,
  };

  if (getActiveData[cardType].totalPages > 1)
    return (
      <div className="Pagination mt-1 mb-1 d-flex justify-content-center">
        <ReactPaginate
          activeClassName={"item active"}
          breakClassName={"item break-me"}
          breakLabel={"..."}
          containerClassName={"pagination"}
          disabledClassName={"disabled-page"}
          marginPagesDisplayed={1}
          nextClassName={"item next"}
          onPageChange={(page) => update({ page: page.selected + 1 })}
          pageCount={getActiveData[cardType].totalPages}
          pageClassName={"item pagination-page "}
          pageRangeDisplayed={2}
          previousClassName={"item previous"}
          previousLabel={
            <div className="d-flex">
              <img
                src={
                  require(`@src/assets/images/icons/previous-arrow.png`).default
                }
                width={20}
              />
              <span className="PagItem"> Previous</span>
            </div>
          }
          nextLabel={
            <div className="d-flex">
              <span className="PagItem">Next </span>
              <img
                src={require(`@src/assets/images/icons/next-arrow.png`).default}
                alt=""
                width={20}
              />
            </div>
          }
          forcePage={getActiveParams[cardType].page - 1}
        />
      </div>
    );
  else return null;
};

export default Pagination;
